import { render, staticRenderFns } from "./printReceipt.vue?vue&type=template&id=5f05fc7c"
import script from "./printReceipt.vue?vue&type=script&lang=js"
export * from "./printReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports